import React, { FC, useCallback, useMemo, useState } from 'react';
import { Dropdown, Menu } from 'antd';
import styles from './FilterSelect.module.less';
import { ContentBlock } from '../../uicomp/atmos/content-block/ContentBlock';
import { CaretDownOutlined } from '@ant-design/icons';
import Utils from '../../utils/Utils';

type Props = {
  title: string;
  id?: string;
  calculateCount?: (value?: any) => number | undefined;
} & any;

export const FilterSelect: FC<Props> = (props) => {
  const { title, value, children, calculateCount, id } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const count = useMemo(
    () =>
      value && Array.isArray(value)
        ? value.length
        : calculateCount
        ? calculateCount(value)
        : undefined,
    [calculateCount, value],
  );
  const onChange = useCallback(
    (val: any) => {
      props.onChange?.(val);
      setVisible(false);
    },
    [props],
  );
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...props, onChange, onCancel: () => setVisible(false) });
    }
    return child;
  });

  return (
    <Dropdown
      open={visible}
      onOpenChange={setVisible}
      getPopupContainer={(props1: any) => props1.parentNode}
      destroyPopupOnHide
      overlayClassName={styles.overlay}
      overlay={<Menu>{childrenWithProps}</Menu>}
      trigger={['click']}>
      <ContentBlock
        id={id}
        align={'center'}
        right={<CaretDownOutlined />}
        level={-2}
        className={Utils.mergeClasses({
          [styles.filterSelectDisplay]: true,
          [styles.filterSelectDisplaySelected]: !!value,
        })}>
        <ContentBlock
          align={'center'}
          level={-1}
          right={count && <div className={styles.filterSelectCount}>{count}</div>}>
          {title}
        </ContentBlock>
      </ContentBlock>
    </Dropdown>
  );
};
